<template>
    <div>
        <button @click="show(modalName)">Read more</button>

        <modal :name="modalName" classes="textImageModal" height="auto" :scrollable="true">
            <h1 v-html="this.modalData.title"></h1>
            <h2 v-html="this.modalData.subtitle"></h2>
            <div class="description" v-html="this.modalData.description"></div>
            <a v-if="modalData.url" :href="this.modalData.url" target="_blank">Linkedin</a>
            <div class="buttonGroup">
                <button class="buttonClose" @click="hide(modalName)">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        modalName: {
            type: String,
            required: true,
        },
        modalContent: {
            type: String,
            required: true,
        },
    },
    computed: {
        modalData() {
            return JSON.parse(this.modalContent);
        },
    },
    methods: {
        show(modal) {
            this.$modal.show(modal);
        },
        hide(modal) {
            this.$modal.hide(modal);
        }
    }
}
</script>
